// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__8i0o1","top":"styles_top__i4iQJ","block":"styles_block__goIAX","mobWrapper":"styles_mobWrapper__P8zXw","deskWrapper":"styles_deskWrapper__GlrSJ"};